
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4168 21.8725C12.5329 20.8274 12 19.4759 12 18C12 14.6863 14.6863 12 18 12C19.0023 12 19.9472 12.2458 20.7778 12.6804V4.90476L11.8889 2L3 4.90476V13.4286C3 15.7019 3.93651 17.882 5.6035 19.4895C7.27049 21.0969 9.53141 22 11.8889 22C12.4046 22 12.9156 21.9568 13.4168 21.8725ZM17.1727 9.73994L11.6727 14.7399L10.9671 15.3813L10.2929 14.7071L7.29289 11.7071L8.70711 10.2929L11.0329 12.6187L15.8273 8.26006L17.1727 9.73994Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.134 15.0359L15.866 12.3038L16.5438 13.4777C18.6294 12.8038 20.9735 13.6502 22.1136 15.625C22.9932 17.1484 22.9321 18.9559 22.1143 20.3751L20.8147 19.6262C21.3761 18.6519 21.4156 17.416 20.8146 16.375C20.0916 15.1227 18.661 14.5336 17.3194 14.8212L17.866 15.7679L15.134 15.0359ZM15.1854 16.3738C14.6239 17.3481 14.5844 18.584 15.1854 19.625C15.9084 20.8773 17.339 21.4664 18.6806 21.1788L18.134 20.232L20.866 20.9641L20.134 23.6961L19.4563 22.5223C17.3706 23.1962 15.0265 22.3498 13.8864 20.375C13.0068 18.8515 13.0679 17.0441 13.8857 15.6249L15.1854 16.3738Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowimagecodeFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
